import { useMemo } from "react";
import STYLES from "components/common/Select/styles";

export default function useStyles(styles) {
  return useMemo(() => {
    if (!styles) return STYLES;

    return Object.entries(styles).reduce(
      (acc, [key, customCallback]) => {
        const defaultCallback = acc[key];
        if (!defaultCallback) {
          acc[key] = customCallback;
          return acc;
        }

        acc[key] = (...args) => ({ ...defaultCallback(...args), ...customCallback(...args) });

        return acc;
      },
      { ...STYLES },
    );
  }, [styles]);
}
